/**
 * EmptyNotifications Component
 *
 * Empty state displayed when user has no notifications.
 * Shows a friendly message with a bell icon.
 */

'use client';

import { Bell } from 'lucide-react';
import { useTranslations } from 'next-intl';

interface EmptyNotificationsProps {
  locale: string;
}

export function EmptyNotifications({ locale }: EmptyNotificationsProps) {
  const t = useTranslations('notifications.empty');

  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
      <Bell className="h-12 w-12 text-text-secondary mb-3" />
      <p className="text-text-primary font-medium">{t('title')}</p>
      <p className="text-text-secondary text-sm mt-1">{t('description')}</p>
    </div>
  );
}
